const data = {
  data: {
    Respuesta: '',
    blnError: false,
    codError: null,
    msgError: null
  }
}
  
export default data
